export const slugify = (str) => {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-") // replace spaces & special chars with dashes
    .replace(/(^-|-$)/g, ""); // remove leading/trailing dashes
};
